import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        //-- 当前用户信息
        userInfo: {},
         //-- 当前客服用户信息
         CuserviceInfo: {},
        //-- 注册信息
        registerInfo: {},
        //-- 密码找回信息
        forgetPwdInfo: {},
        //-- 代办事项
        todoInfo:{ },
        // 注册手机号
        BurtmobilePhone:{},
        //-- 银行卡管理
        bankInfo:{ },
        //-- 错误信息提示
        errorInfo:{ 
            type:'fail',
            msg:''
        },
        //赎回专认购的温馨提示
        reminderSHZRG:false,
        //接口防刷 凭证
        ticket:'',
        //记录当前路由,供下个页面依赖用
        relyOnRouter:'',
        pwdBtnState:true // 密码提交按钮的状态
    },
    getters:{

    },
    mutations: {
            /*
         * 更新用户信息
         * @param {现 userInfo} state 
         * @param {新 userInfo} newUInfo 
         */
        upBurtBankResetInfo:function(state,NewsBurtBankResetInfo){ 
            if(NewsBurtBankResetInfo == null){
                state.BurtBankResetInfo = {}
            }else{
                //遍历 新用户信息,更新状态里的 对应的信息
                for(let u in NewsBurtBankResetInfo){
                    state.BurtBankResetInfo = NewsBurtBankResetInfo[u];
                }
            }
            //如果包含 token
            if( state.userInfo.token){
                //跟新 cookie
                //tools.updataCookie('c_name',tmpUsr.token);
            }
        },
         /*
         * 重置手机号信息
         * @param {现 BurtmobilePhone} state 
         * @param {新 BurtmobilePhone} newBurtmobilePhone 
         */
        upBurtresetmobilePhone:function(state,newBurtresetmobilePhone){ 
            if(newBurtresetmobilePhone == null){
                state.BurtresetmobilePhone = {}
            }else{
                
                    state.BurtresetmobilePhone = newBurtresetmobilePhone;
            }
        },
           /*
         * 重置Token信息
         * @param {现 BurtmobilePhone} state 
         * @param {新 BurtmobilePhone} newBurtmobilePhone 
         */
        upBurtresetToken:function(state,newBurtresetToken){ 
            if(newBurtresetToken == null){
                state.BurtresetToken = {}
            }else{
                    state.BurtresetToken = newBurtresetToken;
            }
        },
          /*
         * 注册手机号信息
         * @param {现 BurtmobilePhone} state 
         * @param {新 BurtmobilePhone} newBurtmobilePhone 
         */
        upBurtmobilePhone:function(state,newBurtmobilePhone){ 
            if(newBurtmobilePhone == null){
                state.BurtmobilePhone = {}
            }else{
                
                    state.BurtmobilePhone = newBurtmobilePhone;
            }
        },
           /*
         * 客服用户信息
         * @param {现 CuserviceInfo} state 
         * @param {新 CuserviceInfo} newUInfo 
         */
        upCuserviceInfo:function(state,newUserInfo){ 
            if(newUserInfo == null){
                state.userInfo = {}
            }else{
                //遍历 新用户信息,更新状态里的 对应的信息
                for(let u in newUserInfo){
                    state.userInfo[u] = newUserInfo[u];
                }
            }
            //如果包含 token
            if( state.userInfo.token){
                //跟新 cookie
                //tools.updataCookie('c_name',tmpUsr.token);
            }
        },
        /*
         * 更新用户信息
         * @param {现 userInfo} state 
         * @param {新 userInfo} newUInfo 
         */
        upUserInfo:function(state,newUserInfo){ 
          // debugger
            if(newUserInfo == null){
                state.userInfo = {}
            }else{
                //遍历 新用户信息,更新状态里的 对应的信息
                for(let u in newUserInfo){
                    state.userInfo[u] = newUserInfo[u];
                }
            }
            //如果包含 token
            if( state.userInfo.token){
                //跟新 cookie
                //tools.updataCookie('c_name',tmpUsr.token);
            }
        },
        /*
         * 更新注册信息
         * @param {现 registerInfo} state 
         * @param {新 registerInfo} newRegisterInfo 
         */
        upRegisterInfo:function(state,newRegisterInfo){ 
            if(newRegisterInfo == null){
                state.registerInfo = {}
            }else{
                //遍历 注册信息,更新状态里的 对应的信息
                for(let r in newRegisterInfo){
                    //跟新此属性
                    state.registerInfo[r] = newRegisterInfo[r];
                }
            }
        },
        /*
         * 密码找回信息
         * @param {现 forgetPwdInfo } state 
         * @param {新 forgetPwdInfo} newForgetPwdInfo 
         */
        upForgetPwdInfo:function(state,newForgetPwdInfo){
            if(newForgetPwdInfo != null){
                 //遍历密码找回信息,更新状态里的 对应的信息
                for(let u in newForgetPwdInfo){
                    state.forgetPwdInfo[u] = newForgetPwdInfo[u];
                }
            }else{
                state.forgetPwdInfo = {}; //用于清空数据
            }
        },
        /*
         * 代办事项信息
         * @param {现 todoInfo } state 
         * @param {新 todoInfo} newTodoInfo 
         */
        upTodoInfo:(state,newTodoInfo) => {
            if(newTodoInfo != null){
                //遍历 代办事项信息,更新状态里的 对应的信息
                for(let t in newTodoInfo){
                    state.todoInfo[t] = newTodoInfo[t];
                }
            }else{
                state.todoInfo = {}; //用于清空数据
            }
        },
        /*
         * 银行卡信息
         * @param {现 upBankInfo } state 
         * @param {新 upBankInfo} newBankInfo 
         */
        upBankInfo:(state,newBankInfo) => {
            if(newBankInfo != null){
                //遍历银行卡信息,更新状态里的 对应的信息
                for(let b in newBankInfo){
                    state.bankInfo[b] = newBankInfo[b];
                }
            }else{
                state.bankInfo = {}; //用于清空数据
            }
        },
         /* 
         * 显示错误信息
         * @param {现 userInfo} state 
         * @param {新 userInfo} newUInfo 
         */
        showErrorInfo:(state,errorInfoObj) => {
            state.errorInfo = errorInfoObj;
            //启动定时器,2500毫秒后自动隐藏
            let timer = setTimeout(()=>{
                clearTimeout(timer);
                timer = null;
                state.errorInfo = {
                    type:'fail',
                    msg:''
                };
            },2500)
        },
        /*
         * 显示 或 隐藏 赎回转认购的温馨提示
         * @param isShow true or false
        */
        upReminderSHZRG:(state,isShow) => {  
            state.reminderSHZRG = isShow;
        },
        /*
         * 接口 凭证
         * @param isShow true or false
        */
        upTicket(state,ticket){  
            state.ticket = ticket;
        },
        /*
         * 记录当前路由,供下个页面依赖用
         * @param relyOnRouter
        */
        upRelyOnRouter:(state,relyOnRouter) => {
            state.relyOnRouter = relyOnRouter;
        },
        /*
         * 密码提交按钮的状态
         * @param btnState
        */
        upPwdBtnState:(state,btnState) => {
            state.pwdBtnState = btnState;
        }
    }
})

export default store; 


// WEBPACK FOOTER //
// ./src/store/index.js